
/* Cart Note */
function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

class CartNote extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
                ...fetchConfig(),
                ...{ body }
            });
        }, 300))
    }
}
customElements.define('cart-note', CartNote);


/* Open Cart Note */
let data = sessionStorage.getItem('openDetails');
var cartNote = document.getElementById("cart-note__details");
var cartNoteDrawer = document.getElementById("cart-drawer__check");

function openDetails() {
    let data2 = sessionStorage.getItem('openDetails');
    if (data2 == "true") {
        sessionStorage.clear();
        if (cartNoteDrawer) cartNoteDrawer.removeAttribute("open");
    } else {
        sessionStorage.setItem('openDetails', 'true');
        if (cartNoteDrawer) cartNoteDrawer.setAttribute("open", "");
    }
}

if (data == "true") {
    if (cartNote) cartNote.setAttribute("open", "");
    if (cartNoteDrawer) cartNoteDrawer.setAttribute("open", "");
} else {
    if (cartNote) cartNote.removeAttribute("open");
    if (cartNoteDrawer) cartNoteDrawer.removeAttribute("open");
}

function clearForm(e) {
    var textBox = e.parentNode.querySelector("textarea");
    if (e.parentNode.hasAttribute("open")) textBox.value = "";
}

function assignValue(e, vName) {
  const elements = document.querySelectorAll(vName);
  elements.forEach(el => { el.innerHTML = e.value; });
}

var swiperContainerC = document.querySelectorAll(".carousel_card");
for (var i = 0; i < swiperContainerC.length; i++) {
    swiperContainerC[i].classList.add("swiperC" + i);
    const swiperPage = swiperContainerC[i].querySelector(".swiper-pagination");
    if (swiperPage) swiperPage.classList.add("pageC" + i);

    new Swiper(".swiperC" + i, {
        direction: "horizontal",
        autoHeight: false,
        slidesPerView: 1,
        simulateTouch: true,
        touchMove: true,
        speed: 200,
        centeredSlides: true,
        preventClicks: true,
        preventClicksPropagation: true,
        pagination: { el: '.pageC' + i, clickable: true },
    });
}

const swiperContainerU = document.getElementsByClassName("carousel_upsells");
for (var i = 0; i < swiperContainerU.length; i++) {
    swiperContainerU[i].classList.add("swiperU" + i);

    var mySwiperU = new Swiper(".swiperU" + i, {
        enabled: false,
        direction: "horizontal",
        loop: false,
        autoHeight: false,
        slidesPerView: "auto",
        simulateTouch: true,
        touchMove: true,
        speed: 300,
        centeredSlides: false,
        preventClicks: true,
        preventClicksPropagation: true,
        mousewheel: {
            invert: false,
            forceToAxis: true
        },
        freeMode: {
            enabled: true,
            momentum: false,
            momentumBounce: false
        },
        breakpoints: {
            1024: {
                enabled: true
            }
          }
    });
}
const swiperContainerG = document.getElementsByClassName("carousel_gallery");
const swiperContainerP = document.getElementsByClassName("carousel_product");

(function productVariantSwiperFix(){
  const norm = s => (s || '').toLowerCase().trim();

  function getCurrentStone(root){
    const r = root.querySelector('.product__variants input.product-swatch[name*="Stone"]:checked');
    return norm(r ? (r.getAttribute('data-stone-label') || r.value) : '');
  }

  function getAlt(slide){
    return norm(
      slide?.getAttribute('data-alt') ||
      slide?.querySelector('img')?.getAttribute?.('alt') ||
      ''
    );
  }

  function isHiddenSlide(slide){
    return slide.classList.contains('is-mv-hidden');
  }

function firstVisibleIndex(slides, start = 0, dir = +1){
  const n = slides.length;

  if (dir > 0) {
    for (let i = start + 1; i < n; i++) {
      if (!isHiddenSlide(slides[i])) return i;
    }
  } else {
    for (let i = start - 1; i >= 0; i--) {
      if (!isHiddenSlide(slides[i])) return i;
    }
  }

  return -1; 
}


function snapToVisible(sw, dir){
  if (!sw) return;

  const slides = Array.from(sw.slides || []);
  const curr = sw.activeIndex ?? 0;

  if (!slides[curr] || !isHiddenSlide(slides[curr])) return;

  const target = firstVisibleIndex(slides, curr, dir);


  if (target === -1) {

    const edge = dir > 0
      ? slides.map((s,i)=>!isHiddenSlide(s)?i:-1).filter(i=>i>=0).pop()
      : slides.findIndex(s=>!isHiddenSlide(s));

    if (edge >= 0 && edge !== curr) {
      sw.slideTo(edge, 0, false);
    }
    return;
  }

  sw.slideTo(target, 0, false);
}


  function filterOne(root, upperEl, thumbsEl, lightboxEl){
    const stone = getCurrentStone(root);

    // Upper
    if (upperEl){
      const slides = Array.from(upperEl.querySelectorAll('.swiper-wrapper > .swiper-slide'));
      let any = false;

      slides.forEach(sl => {
        const alt = getAlt(sl);
        const ok = !stone || (alt && alt.includes(stone));
        sl.classList.toggle('is-mv-hidden', !ok);
        if (ok) any = true;
      });

      if (!any) slides.forEach(sl => sl.classList.remove('is-mv-hidden'));

      const sw = upperEl.swiperInstance || upperEl.swiper;
      if (sw){
        try { sw.update(); } catch(e){}
        snapToVisible(sw, +1);
      }
    }

    // Thumbs
    if (thumbsEl){
      const tSlides = Array.from(thumbsEl.querySelectorAll('.swiper-wrapper > .swiper-slide'));
      let anyT = false;

      tSlides.forEach(sl => {
        const alt = getAlt(sl);
        const ok = !stone || (alt && alt.includes(stone));
        sl.classList.toggle('is-mv-hide', !ok);
        if (ok) anyT = true;
      });

      if (!anyT) tSlides.forEach(sl => sl.classList.remove('is-mv-hide'));

      const swT = thumbsEl.swiperInstance || thumbsEl.swiper;
      if (swT){
        try { swT.update(); } catch(e){}
      }
    }

    if (lightboxEl){
      const lSlides = Array.from(lightboxEl.querySelectorAll('.swiper-wrapper > .swiper-slide'));
      let anyL = false;

      lSlides.forEach(sl => {
        const alt = getAlt(sl);
        const ok = !stone || (alt && alt.includes(stone));
        sl.classList.toggle('is-mv-hidden', !ok);
        if (ok) anyL = true;
      });

      if (!anyL) lSlides.forEach(sl => sl.classList.remove('is-mv-hidden'));

      const swL = lightboxEl.swiperInstance || lightboxEl.swiper;
      if (swL){
        try { swL.update(); } catch(e){}
        snapToVisible(swL, +1);
      }
    }
  }

  for (let i = 0; i < swiperContainerP.length; i++) {
    const upperEl  = swiperContainerP[i];
    const thumbsEl = swiperContainerG[i];

    const root = upperEl.closest('[data-template^="product"], [id^="shopify-section-"], section')
              || document;

    upperEl.classList.add("swiperP" + i);
    thumbsEl.classList.add("swiperG" + i);

    // Thumbs swiper
    const mySwiperG = new Swiper(".swiperG" + i, {
      direction: "horizontal",
      slidesPerView: 'auto',
      spaceBetween: 10,
      simulateTouch: true,
      speed: 300,
      mousewheel: { invert: false, forceToAxis: true },
      freeMode: { enabled: true, momentum: false, momentumBounce: false },
      watchSlidesProgress: true,
      watchSlidesVisibility: true
    });
    thumbsEl.swiperInstance = mySwiperG;

    // Upper swiper
    const mySwiperP = new Swiper(".swiperP" + i, {
      direction: "horizontal",
      loop: false,
      slidesPerView: 1,
      speed: 300,
      centeredSlides: true,
      preventClicks: true,
      preventClicksPropagation: true,
      effect: "fade",
      fadeEffect: { crossFade: true },
      thumbs: { swiper: mySwiperG },
      simulateTouch: true,
      passiveListeners: false,
      touchStartPreventDefault: false,
      watchOverflow: true,
      on: {
        slideChangeTransitionStart() {
          const dir = (this.activeIndex >= (this.previousIndex ?? 0)) ? +1 : -1;
          snapToVisible(this, dir);
        },
        touchEnd() {
          snapToVisible(this, +1);
          snapToVisible(this, -1);
        }
      }
    });
    upperEl.swiperInstance = mySwiperP;

    mySwiperP.on("slideChange", function () {
      const idx = mySwiperP.activeIndex;
      thumbsEl.querySelectorAll(".product__gallery-item").forEach((s) => s.classList.remove("active"));
      const newActiveThumb = thumbsEl.querySelectorAll(".product__gallery-item")[idx];
      if (newActiveThumb) newActiveThumb.classList.add("active");
    });

    function runFilter(){
      const lightboxEl = root.querySelector('.carousel_lightbox');
      filterOne(root, upperEl, thumbsEl, lightboxEl);
    }

    runFilter();

    root.addEventListener('change', (e) => {
      if (e.target.matches('.product__variants input.product-swatch[name*="Stone"]')) {
        runFilter();
      }
    });

    const mo = new MutationObserver(() => setTimeout(runFilter, 50));
    mo.observe(root, { childList: true, subtree: true });
  }
})();

/* =============================
   Lightbox / Gallery (ONLY) — desktop-like mobile behavior
   ============================= */
const swiperContainerL = document.getElementsByClassName("carousel_lightbox");
const lightboxSwipers = [];
window.__lightboxSwipers = lightboxSwipers;
let mySwiperL;

const isYT = (s) => /youtube\.com|youtu\.be/i.test(s || "");
const isVM = (s) => /vimeo\.com/i.test(s || "");

function pauseIframe(f) {
  try {
    const src = f.getAttribute("src") || "";
    if (isYT(src)) {
      f.contentWindow?.postMessage(JSON.stringify({ event: "command", func: "pauseVideo" }), "*");
    } else if (isVM(src)) {
      f.contentWindow?.postMessage({ method: "pause" }, "*");
    }
    f.__playing = false;
  } catch (e) {}
}

function playIframe(f) {
  try {
    const src = f.getAttribute("src") || "";
    const u = new URL(f.src, location.href);
    if (isYT(src)) {
      u.searchParams.set("enablejsapi", "1");
      u.searchParams.set("playsinline", "1");
      u.searchParams.set("origin", location.origin);
    } else if (isVM(src)) {
      u.searchParams.set("api", "1");
    }
    if (f.src !== u.toString()) f.src = u.toString();
    if (!f.hasAttribute("allow")) f.setAttribute("allow", "autoplay; encrypted-media; picture-in-picture");
    if (isYT(src)) {
      f.contentWindow?.postMessage(JSON.stringify({ event: "command", func: "playVideo" }), "*");
    } else if (isVM(src)) {
      f.contentWindow?.postMessage({ method: "play" }, "*");
    }
    f.__playing = true;
  } catch (e) {}
}

function pauseAll(scope) {
  (scope || document).querySelectorAll("video").forEach(v => { try { v.pause(); } catch(e){} });
  (scope || document).querySelectorAll("iframe").forEach(f => pauseIframe(f));
}

function ensureClickShield(wrap) { return null; }

function wireOneWrap(wrap) {
  if (!wrap || wrap.__wired) return;
  wrap.__wired = true;

  const v = wrap.querySelector("video");
  const f = v ? null : wrap.querySelector("iframe");

  if (v) {
    v.removeAttribute("autoplay");
    v.autoplay = false;
    try { v.pause(); } catch(e){}
    v.addEventListener("loadedmetadata", () => { try { v.pause(); } catch(e){} });
  }

  if (f) pauseIframe(f);

  const shield = ensureClickShield(wrap);
  if (shield) shield.onclick = () => {};
}

function wireLightboxVideos(lightboxEl) {
  if (!lightboxEl) return;
  const wraps = lightboxEl.querySelectorAll(".product__video-wrap");
  if (!wraps.length) return;
  wraps.forEach(wireOneWrap);
}

/* Init each lightbox swiper & wire videos */
for (var i = 0; i < swiperContainerL.length; i++) {
  const el = swiperContainerL[i];
  el.classList.add("swiperL" + i);

  const swiperNextL = el.querySelector(".swiper-button-next");
  const swiperPrevL = el.querySelector(".swiper-button-prev");
  if (swiperNextL) swiperNextL.classList.add("nextL" + i);
  if (swiperPrevL) swiperPrevL.classList.add("prevL" + i);

  const maxZoomRatio = window.innerWidth > 1024 ? 3 : 5;

  mySwiperL = new Swiper(".swiperL" + i, {
    zoom: { maxRatio: maxZoomRatio },
    direction: "horizontal",
    loop: false,
    autoHeight: false,
    slidesPerView: 1,
    simulateTouch: true,
    touchMove: true,
    effect: "fade",
    speed: 300,
    centeredSlides: true,
    fadeEffect: { crossFade: true },
    navigation: { nextEl: ".nextL" + i, prevEl: ".prevL" + i },
    preventClicks: false,
    preventClicksPropagation: false,
    touchStartPreventDefault: false,
    passiveListeners: false,
    nested: true,
    on: {
      slideChangeTransitionStart() { pauseAll(el); }
    }
  });

  Object.assign(mySwiperL.params, {
    allowTouchMove: true,
    noSwiping: false,
    noSwipingClass: "__never__",
    touchStartPreventDefault: false,
    passiveListeners: true,
  });
  try { mySwiperL.update(); } catch(e){}

  el.querySelectorAll(".swiper-slide.is-video").forEach((slide) => {
    slide.removeAttribute("data-swiper-no-swiping");
    slide.classList.remove("swiper-no-swiping");
  });

  const scrubNoSwiping = () => {
    el.querySelectorAll('[data-swiper-no-swiping], .swiper-no-swiping')
      .forEach(n => { n.removeAttribute?.('data-swiper-no-swiping'); n.classList?.remove('swiper-no-swiping'); });
    mySwiperL.params.allowTouchMove = true;
    mySwiperL.params.noSwiping = false;
    mySwiperL.params.noSwipingClass = '__never__';
  };
  scrubNoSwiping();
  const moNoSwipe = new MutationObserver(scrubNoSwiping);
  moNoSwipe.observe(el, { childList: true, subtree: true });

  lightboxSwipers.push(mySwiperL);
  window.mySwiperL = mySwiperL;

  wireLightboxVideos(el);
  pauseAll(el);

  const mo = new MutationObserver((muts) => {
    let added = false;
    muts.forEach(m => { if (m.addedNodes && m.addedNodes.length) added = true; });
    if (added) {
      wireLightboxVideos(el);
      scrubNoSwiping();
      try { mySwiperL.update(); } catch(e){}
    }
  });
  mo.observe(el, { childList: true, subtree: true });

  mySwiperL.on('zoomChange', function(swiper, scale) {
      swiper.allowSlideNext = swiper.allowSlidePrev = (scale === 1);
      if (scale > 1) swiper.el.classList.add('swiper-zoomed');
      else swiper.el.classList.remove('swiper-zoomed');
  });

  // Desktop single-click zoom toggle (unchanged)
  if (window.innerWidth > 1024) {
      let slides = el.querySelectorAll('.swiper-slide');
      slides.forEach(function(slide) {
          let zc = slide.querySelector('.swiper-zoom-container');
          if (!zc) return;
          let startX, startY, moved, thr = 5;

          zc.addEventListener('pointerdown', function(e) {
              startX = e.clientX; startY = e.clientY; moved = false;
              zc.setPointerCapture(e.pointerId);
              zc.classList.add('manipulating');
          });
          zc.addEventListener('pointermove', function(e) {
              if (startX === undefined) return;
              if (Math.abs(e.clientX - startX) > thr || Math.abs(e.clientY - startY) > thr) moved = true;
          });
          zc.addEventListener('pointerup', function(e) {
              zc.releasePointerCapture(e.pointerId);
              if (startX !== undefined) {
                  if (Math.abs(e.clientX - startX) > thr || Math.abs(e.clientY - startY) > thr) moved = true;
              }
              zc.classList.remove('manipulating');
              if (!moved) {
                  if (mySwiperL.zoom.scale === 1) mySwiperL.zoom.in(e);
                  else mySwiperL.zoom.out();
              }
              startX = undefined; startY = undefined;
          });
          zc.addEventListener('pointerleave', function() { zc.classList.remove('manipulating'); });
      });
  }
}

// Handle Lightbox close (unchanged)
const lightboxButton = document.querySelector('.product__lightbox-button');
if (lightboxButton) {
  lightboxButton.addEventListener('click', function() {
    if (mySwiperL && mySwiperL.zoom && typeof mySwiperL.zoom.out === 'function') mySwiperL.zoom.out();
    if (mySwiperL) { mySwiperL.allowSlideNext = true; mySwiperL.allowSlidePrev = true; }
    const lightboxScope = document.querySelector('.carousel_lightbox');
    if (lightboxScope) pauseAll(lightboxScope);

    let activeIndex = mySwiperL ? mySwiperL.activeIndex : 0;
    let thumbnails = document.querySelectorAll('.carousel_gallery .product__gallery-item');
    if (thumbnails && thumbnails.length > activeIndex) thumbnails[activeIndex].click();
  });
}

// Keep galSlide API the same
function galSlide(e) {
    if (mySwiperL && typeof mySwiperL.slideTo === "function") {
      mySwiperL.slideTo(e-1);
      const lightboxScope = document.querySelector('.carousel_lightbox');
      if (lightboxScope) pauseAll(lightboxScope);
    }
}

const swiperContainerR = document.getElementsByClassName("carousel_review");
for (var i = 0; i < swiperContainerR.length; i++) {
    swiperContainerR[i].classList.add("swiperR" + i);
    const swiperPage = swiperContainerR[i].querySelector(".swiper-pagination");
    if (swiperPage) swiperPage.classList.add("pageR" + i);

    var pagination = swiperContainerR[i].querySelectorAll("p");
    new Swiper(".swiperR" + i, {
        direction: "horizontal",
        loop: true,
        autoHeight: true,
        slidesPerView: 1,
        effect: "fade",
        speed: 300,
        centeredSlides: true,
        fadeEffect: { crossFade: true },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="font_up ' + className + '">' + (pagination[index].getAttribute("data-quote")) + '</span>';
            },
        },
        autoplay: { delay: 5000 },
    });
}

const swiperContainerM = document.getElementsByClassName("carousel_multi");
for (var i = 0; i < swiperContainerM.length; i++) {
    swiperContainerM[i].classList.add("swiperM" + i);

    const swiperNextM = swiperContainerM[i].querySelector(".swiper-button-next");
    const swiperPrevM = swiperContainerM[i].querySelector(".swiper-button-prev");
    if (swiperNextM) swiperNextM.classList.add("nextM" + i);
    if (swiperPrevM) swiperPrevM.classList.add("prevM" + i);

    new Swiper(".swiperM" + i, {
        direction: "horizontal",
        slidesPerView: 'auto',
        simulateTouch: true,
        speed: 300,
        mousewheel: { invert: false, forceToAxis: true },
        freeMode: { enabled: false },
        navigation: { nextEl: ".nextM" + i, prevEl: ".prevM" + i },
    });
}

const swiperContainerB = document.getElementsByClassName("bar__container");
for (var i = 0; i < swiperContainerB.length; i++) {
    swiperContainerB[i].classList.add("swiperB" + i);

    var ad = swiperContainerB[i].getAttribute("data-delay") * 1000;

    new Swiper(".swiperB" + i, {
        on: {
            init: function () {
                if (ad > 0) {
                    this.params.autoplay = { delay: ad, disableOnInteraction: false };
                    this.autoplay.start();
                }
            },
        },
        direction: "horizontal",
        loop: true,
        autoHeight: false,
        slidesPerView: 1,
        centeredSlides: true,
        grabCursor: false,
        speed: 200,
        fadeEffect: { crossFade: true },
    });
}

const swiperContainerBa = document.getElementsByClassName("carousel_banner");
for (var i = 0; i < swiperContainerBa.length; i++) {
    swiperContainerBa[i].classList.add("swiperBa" + i);

    var ad = swiperContainerBa[i].getAttribute("data-delay") * 1000;
    var slidesCount = swiperContainerBa[i].querySelectorAll('.swiper-slide');

    const swiperNextBa = swiperContainerBa[i].querySelector('.swiper-button-next');
    const swiperPrevBa = swiperContainerBa[i].querySelector('.swiper-button-prev');
    if (swiperNextBa) swiperNextBa.classList.add('nextBa');
    if (swiperPrevBa) swiperPrevBa.classList.add('prevBa');

    new Swiper('.swiperBa', {
      on: {
        init: function () {
          if (ad > 0) {
            this.params.autoplay = { delay: ad, disableOnInteraction: false };
            this.autoplay.start();
          }
        },
      },
      direction: 'horizontal',
      loop: slidesCount.length > 1,
      watchOverflow: true,
      autoHeight: false,
      slidesPerView: 1,
      simulateTouch: false,
      effect: 'fade',
      speed: 300,
      centeredSlides: true,
      fadeEffect: { crossFade: true },
      navigation: { nextEl: '.nextBa', prevEl: '.prevBa' },
    });
}

/* Toggle Class (Generic) */
function toggleModal(modalName) {
    var modalActive = document.querySelector(modalName);
    if (modalActive.classList.contains("active")) {
        document.body.classList.remove("active");
        modalActive.classList.remove("active");
    } else {
        document.body.classList.add("active");
        modalActive.classList.add("active");
    }
}
function toggleClass(modalName, c, check) {
    if (check != true) {
        var modalActive = document.querySelector(modalName);
        modalActive.classList.toggle(c);
    } else {
        modalName.classList.toggle(c);
    }
}
function addClass(modalName, c, check) {
    if (check != true) {
        var modalActive = document.querySelector(modalName);
        modalActive.classList.add(c);
    } else {
        modalName.classList.add(c);
    }
}
function removeClass(modalName, c, check) {
    if (check != true) {
        var modalActive = document.querySelector(modalName);
        modalActive.classList.remove(c);
    } else {
        modalName.classList.remove(c);
    }
}
function removeClassAll(modalNames, c, check) {
    if (check != true) {
        var modalActive = document.querySelectorAll(modalNames);
        for (var i = 0; i < modalActive.length; i++) modalActive[i].classList.remove(c);
    } else {
        for (var i = 0; i < modalNames.length; i++) modalNames[i].classList.remove(c);
    }
}
function toggleSibs(e, sibs, c) {
    var siblings = e.querySelectorAll(sibs);
    for (var i = 0; i < siblings.length; i++) {
        if (siblings[i].classList.contains(c)) siblings[i].querySelector("input").click();
    }
}

/* Header Scroll */
var hBanner = document.querySelector(".main-index");
var pBar = document.querySelector("#shopify-section-main-product-bar");
var pBanner = document.querySelector("[data-template^='product'] section.product");

function scrollEvents() {
    var currentScrollPosH = window.pageYOffset;
    if (hBanner || pBanner) {
        if (currentScrollPosH > 0) headerCont.classList.remove("inactive");
        else headerCont.classList.add("inactive");
    }
    if (pBanner && pBar) {
        if (currentScrollPosH > (pBanner.clientHeight / 2)) pBar.classList.add("scrolled");
        else pBar.classList.remove("scrolled");
    }
    prevScrollposH = currentScrollPosH;
}
scrollEvents();
window.onscroll = function () { scrollEvents(); };

/* Grey List Block */
var listBlocks = document.querySelectorAll(".list__text");
listBlocks.forEach((targetDetail) => {
    targetDetail.addEventListener("mouseover", () => {
        targetDetail.parentNode.classList.add("def");
        targetDetail.parentNode.parentNode.classList.add("ov");
    });
    targetDetail.addEventListener("mouseout", () => {
        targetDetail.parentNode.classList.remove("def");
        targetDetail.parentNode.parentNode.classList.remove("ov");
    });
});

/* List Block Viewport */
var isInViewport = function (elem) {
    var b = elem.getBoundingClientRect();
    return (
        b.left >= 0 && b.right <= (window.innerWidth || document.documentElement.clientWidth) &&
        b.top >= 0 && b.bottom <= ((((window.innerHeight - header.clientHeight) / 2) + (elem.clientHeight * 1.5)) || document.documentElement.clientHeight)
    );
};

var listCont = document.querySelectorAll(".list__container");
if (listCont) {
    for (l = 0; l < listCont.length; l++) {
        var list = listCont[l].querySelectorAll("li");
        if (list) {
            list[0].classList.add("none");
            window.addEventListener('scroll', function () {
                for (i = 0; i < list.length; i++) {
                    if (isInViewport(list[i])) {
                        for (t = 0; t < list.length; t++) list[t].classList.remove("none");
                        list[i].classList.add("none");
                    }
                }
            }, false);
            for (i = 0; i < list.length; i++) {
                if (isInViewport(list[i])) {
                    for (t = 0; t < list.length; t++) list[t].classList.remove("none");
                    list[i].classList.add("none");
                }
            }
        }
    }
}

/* Engraving Text */
function engravingText(e, eText) {
    var engravingText = document.querySelector(eText);
    if (e.value != "") {
        engravingText.removeAttribute("disabled");
        engravingText.value = e.value;
    } else {
        engravingText.value = e.value;
        engravingText.setAttribute("disabled", true);
    }
}
function toggleAttr(e, eText, eInput) {
    var engravingText = document.querySelector(eText);
    var engravingInput = document.querySelector(eInput);
    if (e.classList.contains("active")) {
        engravingText.setAttribute("disabled", true);
        engravingInput.value = "";
    }
}

/* Close Popup */
function closePopup(modalName, cookieName) {
    var modalActive = document.getElementById(modalName);
    modalActive.classList.remove("active");

    var timeToAdd = 1000 * 60 * 60 * 24 * 7 * 4 * 6;
    var date = new Date();
    var expiryTime = parseInt(date.getTime()) + timeToAdd;
    date.setTime(expiryTime);
    var utcTime = date.toUTCString();

    document.cookie = cookieName + "=closed; expires=" + utcTime + ";";

    if (modalName == "shopify-section-assets-bar") {
        setTimeout(function () {
            document.documentElement.style.setProperty('--Hh', header.clientHeight + "px");
            document.documentElement.style.setProperty('--Hb', "0px");
        }, 350);
    }
}

/* Cart Notification */
function cartAdd() {
    setTimeout(function () {
        document.body.classList.add("js-my-cart-open");
        addToCartCleanup('.product__variant-option-select');
    }, 1000);
}

/* Overscroll Behaviour */
function stopOverscroll(element) {
    element = gsap.utils.toArray(element)[0] || window;
    (element === document.body || element === document.documentElement) && (element = window);
    let lastScroll = 0, lastTouch, forcing, forward = true,
        isRoot = element === window,
        scroller = isRoot ? document.scrollingElement : element,
        ua = window.navigator.userAgent + "",
        getMax = isRoot ? () => scroller.scrollHeight - window.innerHeight : () => scroller.scrollHeight - scroller.clientHeight,
        addListener = (type, func) => element.addEventListener(type, func, { passive: false }),
        revert = () => { scroller.style.overflowY = "auto"; forcing = false; },
        kill = () => { forcing = true; scroller.style.overflowY = "hidden"; !forward && scroller.scrollTop < 1 ? (scroller.scrollTop = 1) : (scroller.scrollTop = getMax() - 1); setTimeout(revert, 1); },
        handleTouch = (e) => {
          let evt = e.changedTouches ? e.changedTouches[0] : e,
              forward = evt.pageY <= lastTouch;
          if (((!forward && scroller.scrollTop <= 1) || (forward && scroller.scrollTop >= getMax() - 1)) && e.type === "touchmove") { e.preventDefault(); }
          else { lastTouch = evt.pageY; }
        },
        handleScroll = (e) => {
          if (!forcing) {
            let scrollTop = scroller.scrollTop;
            forward = scrollTop > lastScroll;
            if ((!forward && scrollTop < 1) || (forward && scrollTop >= getMax() - 1)) { e.preventDefault(); kill(); }
            lastScroll = scrollTop;
          }
        };
    if ("ontouchend" in document && !!ua.match(/Version\/[\d\.]+.*Safari/)) {
      addListener("scroll", handleScroll);
      addListener("touchstart", handleTouch);
      addListener("touchmove", handleTouch);
    }
    scroller.style.overscrollBehavior = "none";
}

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({});

(function enableVideoTapToggle(){
  const lb = document.querySelector('#product-lightbox .carousel_lightbox');
  if (!lb) return;

  let startX=0, startY=0, dragged=false, activeId=null;
  const THRESH = 8; 

  lb.addEventListener('pointerdown', e => {
    const p = e; startX = p.clientX; startY = p.clientY; dragged = false; activeId = p.pointerId;
  }, {passive:true});

  lb.addEventListener('pointermove', e => {
    if (e.pointerId !== activeId) return;
    if (Math.abs(e.clientX - startX) > THRESH || Math.abs(e.clientY - startY) > THRESH) dragged = true;
  }, {passive:true});

  lb.addEventListener('pointerup', e => {
    if (e.pointerId !== activeId) return;
    activeId = null;
    if (dragged) return; 

    const slide = e.target.closest('.swiper-slide.is-video');
    if (!slide) return;

    const vid = slide.querySelector('video');
    const ifr = vid ? null : slide.querySelector('iframe');
    const inVideoArea = !!e.target.closest('.product__video-wrap, video, iframe');
    if (!inVideoArea) return;

    if (vid) {
      vid.setAttribute('playsinline','');
      // Toggle play/pause
      try { vid.paused ? vid.play() : vid.pause(); } catch(_) {}

      e.stopPropagation(); e.preventDefault();
      return;
    }

    if (ifr) {
      try {
        if (typeof playIframe === 'function' && typeof pauseIframe === 'function') {
          if (ifr.__playing) pauseIframe(ifr);
          else playIframe(ifr);
          e.stopPropagation(); e.preventDefault();
        }
      } catch(_) {}
    }
  }, {passive:false});
})();

/* =============================
   Disable Swiping on Desktop
   ============================= */
(function desktopNoSwipe() {
  const mq = window.matchMedia('(min-width:1024px)');

  function applyNoSwipe(sw, isDesktop) {
    if (!sw) return;
    sw.params.allowTouchMove = !isDesktop;
    sw.allowTouchMove        = !isDesktop;
    sw.params.simulateTouch  = !isDesktop;
    sw.params.grabCursor     = !isDesktop;
    sw.params.touchStartPreventDefault = false;
    sw.params.passiveListeners = true;
    try { sw.update(); } catch(_) {}
  }

  function applyAll() {
    const isDesktop = mq.matches;

    document.querySelectorAll('.carousel_product').forEach(el => {
      const sw = el.swiperInstance || el.swiper;
      if (sw) applyNoSwipe(sw, isDesktop);
    });

    document.querySelectorAll('.carousel_gallery').forEach(el => {
      const sw = el.swiperInstance || el.swiper;
      if (sw) applyNoSwipe(sw, false); 
    });

    document.querySelectorAll('.carousel_lightbox').forEach(el => {
      const sw = el.swiperInstance || el.swiperL || el.swiper;
      if (sw) applyNoSwipe(sw, isDesktop);
    });
  }

  applyAll();
  if (mq.addEventListener) mq.addEventListener('change', applyAll);
  else mq.addListener(applyAll);
})();
/* ============================================
   VARIANT MEDIA FILTER (Stone-locked gallery)
   ============================================ */
(function variantMediaFilter(){
  const root = document.querySelector('[data-template^="product"] #shopify-section-main-product') 
            || document.querySelector('[id^="shopify-section-"][class*="product"]')
            || document.querySelector('#shopify-section-{{ section.id }}'); 
  if (!root) return;

  const norm = s => (s||'').toLowerCase().trim();
  const getAlt = el =>
    norm(el?.getAttribute('data-alt') || el?.querySelector('img')?.getAttribute?.('alt') || '');

  function currentStone(){
    const r = root.querySelector('.product__variants input.product-swatch[name*="Stone"]:checked');
    return norm(r ? (r.getAttribute('data-stone-label') || r.value) : '');
  }

  function visibleIdx(container){
    const slides = Array.from(container.querySelectorAll('.swiper-wrapper > .swiper-slide'));
    return slides.findIndex(sl => !sl.classList.contains('mv-inert') && !sl.classList.contains('is-mv-hide'));
  }

  function firstVisibleIndex(container, start, dir){
    const slides = Array.from(container.querySelectorAll('.swiper-wrapper > .swiper-slide'));
    const n = slides.length; if (!n) return -1;
    for (let step=0; step<n; step++){
      const i = (start + dir*step + n) % n;
      if (!slides[i].classList.contains('mv-inert') && !slides[i].classList.contains('is-mv-hide')) return i;
    }
    return -1;
  }

  function matchSlide(slide, stone){
    if (!stone) return true;            
    const alt = getAlt(slide);
    if (!alt) return false;             
    return alt.includes(stone);
  }


  function filterCarousel(container, mode){

    if (!container) return { any:true };
    const slides = Array.from(container.querySelectorAll('.swiper-wrapper > .swiper-slide'));
    const stone = currentStone();
    let anyMatch = false;

    slides.forEach(sl => {
      const ok = matchSlide(sl, stone);
      if (ok){
        anyMatch = true;
        sl.classList.remove('mv-inert','is-mv-hide');
      } else {

        if (mode === 'thumbs') sl.classList.add('is-mv-hide');
        else sl.classList.add('mv-inert');
      }
    });


    if (!anyMatch){
      slides.forEach(sl => sl.classList.remove('mv-inert','is-mv-hide'));
      anyMatch = true;
    }

    const sw = container.swiper || container.swiperInstance;
    if (sw && typeof sw.update === 'function'){
      try { sw.update(); } catch(_) {}
      const start = typeof sw.activeIndex === 'number' ? sw.activeIndex : 0;
      const target = firstVisibleIndex(container, start, +1);
      if (target >= 0) { try { sw.slideTo(target, 0); } catch(_) {} }
    }

    return { any:anyMatch };
  }

  function filterAll(){
    const upper    = root.querySelector('.carousel_product');
    const thumbs   = root.querySelector('.carousel_gallery');
    const lightbox = root.querySelector('.carousel_lightbox');

    const r1 = filterCarousel(upper, 'upper');
    const r2 = filterCarousel(thumbs, 'thumbs');
    const r3 = filterCarousel(lightbox, 'lightbox');

    const grid = root.querySelector('.product__gallery');
    if (grid){
      const btns = Array.from(grid.querySelectorAll('.product__gallery-item'));
      btns.forEach(b => b.classList.remove('is-hero'));
      const first = btns.find(b => !b.classList.contains('is-mv-hide'));
      if (first) first.classList.add('is-hero');
    }
  }

  function hookSkipHidden(container){
    if (!container) return;
    const sw = container.swiper || container.swiperInstance;
    if (!sw || sw.__mvSkipHook) return;
    sw.__mvSkipHook = true;

    sw.on('slideChangeTransitionStart', () => {
      // direction heuristic
      const prev = sw.previousIndex ?? sw.activeIndex ?? 0;
      const curr = sw.activeIndex ?? prev;
      const dir  = (curr >= prev) ? +1 : -1;
      const target = firstVisibleIndex(container, curr, dir);
      if (target >= 0 && target !== curr){
        try { sw.slideTo(target, 0); } catch(_){}
      }
    });
  }

  function updateLightboxArrows(){
    const lightbox = root.querySelector('.carousel_lightbox');
    if (!lightbox || !lightbox.swiper) return;
    const sw = lightbox.swiper;

    const slides = Array.from(lightbox.querySelectorAll('.swiper-wrapper > .swiper-slide'));
    const visIdx = slides
      .map((s,i)=>({i,hidden:s.classList.contains('mv-inert')||s.classList.contains('is-mv-hide')}))
      .filter(o=>!o.hidden)
      .map(o=>o.i);

    const prevBtn = lightbox.querySelector('.swiper-button-prev');
    const nextBtn = lightbox.querySelector('.swiper-button-next');
    if (!prevBtn || !nextBtn) return;

    if (visIdx.length <= 1){
      [prevBtn,nextBtn].forEach(b => { b.style.visibility='hidden'; b.style.pointerEvents='none'; });
      return;
    }

    const pos = visIdx.indexOf(sw.activeIndex);
    const canPrev = pos > 0;
    const canNext = pos >= 0 && pos < visIdx.length - 1;

    prevBtn.style.visibility = canPrev ? '' : 'hidden';
    prevBtn.style.pointerEvents = canPrev ? '' : 'none';
    nextBtn.style.visibility = canNext ? '' : 'hidden';
    nextBtn.style.pointerEvents = canNext ? '' : 'none';
  }

  function hookLightboxArrows(){
    const lightbox = root.querySelector('.carousel_lightbox');
    if (!lightbox) return;
    const wait = setInterval(()=>{
      if (lightbox.swiper){
        clearInterval(wait);
        const sw = lightbox.swiper;
        if (sw.__mvArrowHook) return;
        sw.__mvArrowHook = true;
        sw.on('slideChangeTransitionStart', updateLightboxArrows);
        sw.on('transitionEnd', updateLightboxArrows);
        updateLightboxArrows();
      }
    }, 60);
    setTimeout(()=>clearInterval(wait), 4000);
  }

  function runAll(){
    filterAll();
    hookSkipHidden(root.querySelector('.carousel_product'));
    hookSkipHidden(root.querySelector('.carousel_lightbox'));
    hookLightboxArrows();
  }

  runAll();

  root.addEventListener('change', (e)=>{
    if (e.target.matches('.product__variants input.product-swatch[name*="Stone"]')) {
      runAll();
    }
  });

  document.addEventListener('click', (e)=>{
    if (e.target.closest('[aria-label="Open Lightbox"], .product__gallery-item')) {
      setTimeout(runAll, 80);
    }
  });

  ['variant:change','product:variant-change'].forEach(evt =>
    root.addEventListener(evt, runAll, {passive:true})
  );

  const mo = new MutationObserver(() => { setTimeout(runAll, 50); });
  mo.observe(root, { childList:true, subtree:true });
})();
